import { NgClass } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AvatarFooterButton, VideoAvatarManagerService } from 'src/app/shared/services/ragai/video-avatar-manager.service';
import { Subscription } from 'rxjs';

// Rendert per Blockly-Block (AVATAR_addFooterButton/AVATAR_clearFooterButtons) gesetzte Footer-Buttons.
@Component({
    selector: 'app-avatar-fullscreen-footer-buttons',
    imports: [NgClass],
    standalone: true,
    templateUrl: './avatar-fullscreen-footer-buttons.component.html',
    styleUrl: './avatar-fullscreen-footer-buttons.component.scss'
})
export class AvatarFullscreenFooterButtonsComponent implements OnInit, OnDestroy {
    public buttons: AvatarFooterButton[] = [];
    private sub = new Subscription();

    constructor(private videoAvatarManager: VideoAvatarManagerService) { }

    public ngOnInit(): void {
        this.sub.add(
            this.videoAvatarManager.onFooterButtonsUpdate.subscribe((buttons) => {
                this.buttons = buttons;
            })
        );
    }

    public ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    public onClick(button: AvatarFooterButton): void {
        void button.onClick();
    }
}
